import { render, staticRenderFns } from "./discountDiaLog.vue?vue&type=template&id=2a615310&scoped=true"
import script from "./discountDiaLog.vue?vue&type=script&lang=js"
export * from "./discountDiaLog.vue?vue&type=script&lang=js"
import style0 from "./discountDiaLog.vue?vue&type=style&index=0&id=2a615310&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a615310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a615310')) {
      api.createRecord('2a615310', component.options)
    } else {
      api.reload('2a615310', component.options)
    }
    module.hot.accept("./discountDiaLog.vue?vue&type=template&id=2a615310&scoped=true", function () {
      api.rerender('2a615310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/quotationManagement/cmp/discountDiaLog.vue"
export default component.exports